import classNames from "classnames";
import React from "react";

import styles from "./style.module.css";

const ModalFooter = ({ showTopBorder = true, children, className }) => {
  if (children) {
    return (
      <div
        className={classNames(styles.container, className, {
          [styles.noTopBorder]: !showTopBorder,
        })}
      >
        {children}
      </div>
    );
  }

  return null;
};

export default ModalFooter;
